import {Query, gql} from 'apollo-angular';
import { Injectable } from '@angular/core';



@Injectable({
    providedIn: 'root'
})
export class BlockQuery extends Query<any> {
    document = gql`
        query BlokQuery(
            $serialNav: Float!
            $fromTS: Float!
            $toTS: Float!
            $monthStartTS: Float!
            $monthEndTS: Float!
            $capped: Boolean
            $timeZone: String
        ) {
            turbines(where: { serialNav: $serialNav }) {
                _id
                code : codeDisplay
                serialNav
                ackCountPerTimeRange(from: $monthStartTS, to: $monthEndTS, timeZone: $timeZone) {
                    checked
                    day
                    edited
                    unchecked
                }
                productionLossMethod {
                    production_loss_calculation {
                        method
                        calculation_method
                        provider
                        references {
                            _id
                            name
                        }
                    }
                }
                turbineLogbook(startTS: $fromTS, endTS: $toTS, capped: $capped, pageSize: 1) {
                    turbineLogbookEntries {
                        _id
                        _id_original
                        _id_turbine
                        _id_process
                        _id_alarm
                        startTS
                        endTS
                        tc
                        tcu
                        ack
                        log
                        component
                        mutTS
                        userComment
                        edited
                        customEvent
                        totalProductionLoss
                        totalRevenueLoss
                        validFromTS
                        validToTS
                        deleted
                        isOpen
                        subBlocks
                        lossesMethod
                        amLossesComment
                        tcmLossesComment
                        lossesConfirmed
                        blockActionsLog
                        eventCode
                        eventDescription
                        controlroomAck
                        controlroomAckLog
                        controlroomTicketing
                        controlroomTicketingLog
                    }
                    turbineLogbookVersions
                    # turbineLogbookEvents {
                    #     _id
                    #     code
                    #     createTS
                    #     type
                    #     description
                    # }
                    turbineMaintainType {
                        startTS
                        endTS
                        type
                        title
                        createdOn
                        turbineCode
                    }
                    parkMaintainType {
                        startTS
                        endTS
                        type
                        title
                        createdOn
                        turbineCode
                    }
                }
                turbineLogbookExport(startTS: $fromTS, endTS: $toTS, capped: $capped, pageSize: 1) {
                    turbineLogbookEntries {
                        _id
                        startTS
                        endTS
                        subBlocks
                    }
                }
            }
        }
    `;
}
